import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import TextHeading from "components/TextHeading";
import useCustomToast from "hooks/useCustomToast";
import usersPaths from "routes/user/list/usersPaths";
import useDeleteUser from "hooks/user/useDeleteUser";
import { CARD_MAX_WIDTH } from "utils/styleHelpers";

type RemoveAccessModalProps = Readonly<{
  userId: string;
  isOpen: boolean;
  onClose: () => void;
}>;

export default function RemoveAccessModal({
  userId,
  isOpen,
  onClose,
}: RemoveAccessModalProps) {
  const { onSuccessToast, onErrorToast } = useCustomToast();

  const navigate = useNavigate();

  const { mutate, isPending } = useDeleteUser(userId, {
    onError: () => {
      onErrorToast({
        title: "Failed to Save Changes",
        message: "Changes were not saved.",
      });
    },
    onSuccess: () => {
      onSuccessToast({
        title: "Access Removed",
        message: "Changes were saved successfully.",
      });
      navigate(`/${usersPaths.basePath}`);
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnEsc={!isPending}
      closeOnOverlayClick={!isPending}
    >
      <ModalOverlay />
      <ModalContent maxW={CARD_MAX_WIDTH}>
        <ModalHeader>
          <TextHeading headingType="h3">Remove Access</TextHeading>
        </ModalHeader>
        <ModalBody>
          <Text>
            This will remove the user from the Riverview system. Do you want to
            continue?
          </Text>

          <Button
            variant="destructive"
            w="full"
            mt={8}
            isLoading={isPending}
            isDisabled={isPending}
            onClick={() => mutate()}
          >
            Remove Access
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            w="full"
            mt={2}
            isDisabled={isPending}
          >
            Cancel
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
